import { useEffect, useRef, useState } from 'react';
// Return explicit height (in pixels) of an element
// Required for smooth exit animation, since it is not possible to animate from auto height in CSS
function useHeight(targetRef) {
    const animateTimer = useRef();
    const [height, setHeight] = useState('auto');
    useEffect(() => {
        const element = targetRef.current;
        if (element != null) {
            cancelAnimationFrame(Number(animateTimer.current));
            animateTimer.current = requestAnimationFrame(() => {
                setHeight(`${element.clientHeight}px`);
            });
        }
        return () => {
            cancelAnimationFrame(Number(animateTimer.current));
        };
    }, [targetRef]);
    return height;
}
export default useHeight;
